$('[target-page]').on('click', function(e){
  e.preventDefault();
  var page = $(this).attr('target-page');
  navigateTo(page);
});

function navigateTo(page) {
  $('html, body').animate({
    scrollTop: $('.page.' + page).offset().top
  }, 1000);
}